import React from 'react';
import { mapValues } from 'lodash';
import { CreateForm } from '../create-form';
import { actions } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
export var Auth = function Auth(_a) {
  var _b = _a.entities,
      sessions = _b.sessions,
      privileges = _b.privileges,
      params = _a.params;
  return React.createElement("div", {
    className: "login-container"
  }, React.createElement("div", {
    className: "login-header"
  }, React.createElement("img", {
    alt: "",
    className: "login-logo",
    src: "/logo-light.png"
  })), React.createElement("div", {
    className: "login-main"
  }, React.createElement(CreateForm, {
    componentId: "login",
    entity: sessions,
    direction: "vertical",
    submit: {
      style: {
        width: '100%'
      },
      text: services.language.getText('components.Auth.login'),
      size: 'large'
    },
    onSubmit: function onSubmit(_event, fields) {
      var entityFields = mapValues(fields, function (field, _name) {
        return field.value;
      });
      sessions.add(entityFields, params, {
        action: actions.loginAction(sessions, privileges)
      }, {});
    },
    fields: [{
      label: '用户名',
      property: 'name',
      controlConfig: {
        prefixIcon: 'user',
        placeholder: 'admin or guest',
        size: 'large'
      }
    }, {
      label: '密码',
      property: 'password',
      controlConfig: {
        prefixIcon: 'lock',
        placeholder: '123',
        size: 'large'
      }
    }]
  })), React.createElement("div", {
    className: "login-footer"
  }, services.language.getText('common.copyrights')));
};